export const SUBMIT = 'PREFERENCES/SUBMIT'
